import React from 'react';

/**
 * Tiroir « Alliances » — port fidèle du prototype (`network.js` drawerAlliances).
 * La mécanique de renfort inter-joueurs n'est pas encore spécifiée : l'accès est
 * réservé au Founder (roles_id = 1). L'entrée reste visible pour signaler
 * que la fonctionnalité arrive.
 */

const ALLIANCES_ROLE_MAX = 1; // Founder uniquement

const ROLE_LABELS: Record<number, string> = {
  1: 'Founder',
  2: 'Team Director',
  3: 'Director of Administration',
  4: 'Director of Moderation',
};
const roleLabel = (r?: number | null): string => ROLE_LABELS[Number(r)] || 'Chef de salle';

interface Props {
  rolesId?: number | null;
}

const AlliancesDrawer: React.FC<Props> = ({ rolesId }) => {
  const ouvert = Number(rolesId ?? 99) <= ALLIANCES_ROLE_MAX;

  if (!ouvert) {
    return (
      <div className="locked">
        <div className="locked__ico">🔒</div>
        <p className="locked__t">Alliances — prévu pour une mise à jour future</p>
        <p className="locked__d">
          La mécanique de renfort entre joueurs n'est pas encore spécifiée : l'accès est réservé au
          Founder le temps de la concevoir. L'entrée reste visible pour que les joueurs
          sachent que ça arrive.
        </p>
        <p className="locked__r mono">
          Accès actuel : {roleLabel(rolesId)} — requis : {ROLE_LABELS[1]}
        </p>
      </div>
    );
  }

  return (
    <>
      <p className="dintro">
        Accès Founder. La mécanique de renfort inter-joueurs reste à spécifier : cet écran
        sera enrichi une fois le design d'alliances arrêté.
      </p>
      <div className="empty">Aucune alliance configurée pour l'instant.</div>
    </>
  );
};

export default AlliancesDrawer;
